export const LEGALSITEPLAN_LOADING = "LEGALSITEPLAN_LOADING";
export const LEGALSITEPLAN_RESET = "LEGALSITEPLAN_RESET";
export const GET_LEGALSITEPLAN = "GET_LEGALSITEPLAN";
export const GET_LEGALSITEPLAN_SUCCESS = "GET_LEGALSITEPLAN_SUCCESS";
export const GET_LEGALSITEPLAN_FAIL = "GET_LEGALSITEPLAN_FAIL";
export const DELETE_LEGALSITEPLAN = "DELETE_LEGALSITEPLAN"
export const DELETE_LEGALSITEPLAN_SUCCESS = "DELETE_LEGALSITEPLAN_SUCCESS"
export const DELETE_LEGALSITEPLAN_FAIL = "DELETE_LEGALSITEPLAN_FAIL"
export const UPDATE_LEGALSITEPLAN = "UPDATE_LEGALSITEPLAN"
export const UPDATE_LEGALSITEPLAN_SUCCESS = "UPDATE_LEGALSITEPLAN_SUCCESS"
export const UPDATE_LEGALSITEPLAN_FAIL = "UPDATE_LEGALSITEPLAN_FAIL"
export const ADD_NEW_LEGALSITEPLAN = "ADD_NEW_LEGALSITEPLAN"
export const ADD_LEGALSITEPLAN_SUCCESS = "ADD_LEGALSITEPLAN_SUCCESS"
export const ADD_LEGALSITEPLAN_FAIL = "ADD_LEGALSITEPLAN_FAIL"